import { render } from "./SavedTablesContainer.vue?vue&type=template&id=aecbf722&scoped=true"
import script from "./SavedTablesContainer.vue?vue&type=script&lang=js"
export * from "./SavedTablesContainer.vue?vue&type=script&lang=js"

import "./SavedTablesContainer.vue?vue&type=style&index=0&id=aecbf722&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aecbf722"]])

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
